<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Dashboard Section
      </p>
      <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
        {{ currentViewTitle }}
      </h2>
    </div>
  </div>
</div>

<div class="grid grid-cols-12 gap-6 bg-gray-50 px-3 pb-10 min-h-screen">

  <!-- LEFT SIDE -->
  <div class="col-span-12 lg:col-span-9">

    <!-- Filters -->
    <div class="mb-6 grid grid-cols-12 gap-4 bg-white border border-gray-300 rounded-2xl p-5 items-end">

      <ng-container *ngIf="shouldShowTopDropdowns || isPageAlerts">

        <!-- Website -->
        <div class="col-span-12" [ngClass]="isPostAlerts ? 'lg:col-span-3' : 'lg:col-span-4'">
          <label class="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Website
          </label>
          <select
            class="w-full cursor-pointer border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
            [ngModel]="selectedSiteId"
            (ngModelChange)="onSiteChange($event)"
          >
            <option value disabled>Select a site</option>
            <option *ngFor="let site of sites" [ngValue]="site.ID">
              {{ site?.Domain }}
            </option>
          </select>
        </div>

        <!-- Platform -->
        <div class="col-span-12" [ngClass]="isPostAlerts ? 'lg:col-span-3' : 'lg:col-span-4'">
          <label class="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Platform
          </label>
          <select
            class="w-full cursor-pointer border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
            [ngModel]="selectedPlatformId"
            (ngModelChange)="onPlatformChange($event)"
          >
            <option value disabled>Select a platform</option>
            <option *ngFor="let platform of filteredPlatforms" [ngValue]="platform.id">
              {{ platform?.platform }}
            </option>
          </select>
        </div>

        <!-- Period -->
        <div *ngIf="showPeriodDropdown && !isPostAlerts" class="col-span-12 lg:col-span-4">
          <label class="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
            Period
          </label>
          <select
            class="w-full cursor-pointer border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
            [(ngModel)]="selectedPeriod"
            (ngModelChange)="onPeriodChange($event)"
          >
            <option [ngValue]="'days_28'">Last 30d</option>
            <option [ngValue]="'week'">Last 7d</option>
          </select>
        </div>

      </ng-container>

      <!-- Format -->
      <div *ngIf="isPostAlerts"
           class="col-span-12"
           [ngClass]="isPostAlerts ? 'lg:col-span-3' : (activeView === 'alerts' ? 'lg:col-span-2' : 'lg:col-span-4')">
        <label class="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
          Format
        </label>
        <select
          class="w-full cursor-pointer border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          [(ngModel)]="selectedFormat"
        >
          <option [ngValue]="null">All formats</option>
          <option *ngFor="let fmt of currentFormats" [ngValue]="fmt.value">
            {{ fmt.label }}
          </option>
        </select>
      </div>

      <!-- Type -->
      <div *ngIf="activeView === 'alerts'"
           class="col-span-12"
           [ngClass]="isPostAlerts ? 'lg:col-span-3' : 'lg:col-span-4'">
        <label class="block text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
          Type
        </label>
        <select
          class="w-full cursor-pointer border border-gray-300 rounded-xl px-4 py-2.5 text-sm text-gray-700 bg-white focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"
          [(ngModel)]="selectedAlertType"
        >
          <option *ngFor="let opt of alertTypeOptions" [ngValue]="opt.value">
            {{ opt.label }}
          </option>
        </select>
      </div>

    </div>

    <!-- Metrics -->
    <div *ngIf="isLoaded && isMetricsLoaded && activeView !== 'format' && activeView !== 'alerts' && !pages?.[0]?.platform?.toLowerCase().includes('tiktok')"
         class="mb-6 grid grid-cols-12 gap-4">

      <!-- Followers -->
      <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-2xl p-5 text-center">
        <p class="text-sm font-medium flex justify-center items-center gap-1">
          Followers
          <mat-icon class="!text-xs text-emerald-500" matTooltip="Total number of followers of the account.">
            info_outline
          </mat-icon>
        </p>

        <ng-container *ngIf="lastChartValue !== null; else followersNA">
          <p class="text-2xl font-bold mt-1">{{ lastChartValue | number }}</p>
          <p class="text-xs mt-1"
             [ngClass]="{
               'text-green-500': diffChartValue! > 0,
               'text-red-500': diffChartValue! < 0,
               'text-gray-500': diffChartValue === 0
             }">
            {{ diffChartValue! > 0 ? '+' + diffChartValue : diffChartValue }}
          </p>
        </ng-container>

        <ng-template #followersNA>
          <p class="text-2xl font-bold text-gray-400">N/A</p>
          <p class="text-xs invisible">placeholder</p>
        </ng-template>
      </div>

      <!-- Reach -->
      <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-2xl p-5 text-center">
        <p class="text-sm font-medium flex justify-center items-center gap-1">
          Reach
          <mat-icon class="!text-xs text-emerald-500" matTooltip="Unique users who saw content from the account.">
            info_outline
          </mat-icon>
        </p>

        <ng-container *ngIf="metrics.reach.value !== null; else reachNA">
          <p class="text-2xl font-bold mt-1">{{ metrics.reach.value | number }}</p>
          <p class="text-xs mt-1"
             [ngClass]="{
               'text-green-500': metrics.reach.diff! > 0,
               'text-red-500': metrics.reach.diff! < 0,
               'text-gray-500': metrics.reach.diff === 0
             }">
            {{ metrics.reach.diff! > 0 ? '+' + (metrics.reach.diff | number) : (metrics.reach.diff | number) }}
          </p>
        </ng-container>

        <ng-template #reachNA>
          <p class="text-2xl font-bold text-gray-400">N/A</p>
        </ng-template>
      </div>

      <!-- Impressions -->
      <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-2xl p-5 text-center">
        <p class="text-sm font-medium flex justify-center items-center gap-1">
          Impressions
          <mat-icon class="!text-xs text-emerald-500" matTooltip="Total number of content views, including repeat views.">
            info_outline
          </mat-icon>
        </p>

        <ng-container *ngIf="metrics.accountImpressions.value !== null; else accImpNA">
          <p class="text-2xl font-bold mt-1">{{ metrics.accountImpressions.value | number }}</p>
        </ng-container>

        <ng-template #accImpNA>
          <p class="text-2xl font-bold text-gray-400">N/A</p>
        </ng-template>
      </div>

      <!-- Profile -->
      <div class="col-span-6 xl:col-span-3 bg-white border border-gray-300 rounded-2xl p-5 text-center">
        <p class="text-sm font-medium flex justify-center items-center gap-1">
          Profile Impressions
        </p>

        <ng-container *ngIf="metrics.profileImpressions.value !== null; else profImpNA">
          <p class="text-2xl font-bold mt-1">{{ metrics.profileImpressions.value | number }}</p>
        </ng-container>

        <ng-template #profImpNA>
          <p class="text-2xl font-bold text-gray-400">N/A</p>
        </ng-template>
      </div>

    </div>

    <!-- Chart -->
    <div>
      <!-- Followers Growth (WITH BORDER) -->
      <div
        *ngIf="activeView === 'followers'"
        class="rounded-2xl border border-gray-300 bg-white p-5"
      >
        <app-social-ai-follower-growth-chart
          [title]="'Follower Growth'"
          [selectedSiteId]="selectedSiteId"
          [selectedPlatformId]="selectedPlatformId"
          [selectedPeriod]="selectedPeriod"
          [pages]="pages"
        >
        </app-social-ai-follower-growth-chart>
      </div>

      <app-social-ai-trends-chart
        *ngIf="activeView === 'trends'"
        [selectedSiteId]="selectedSiteId"
        [selectedPlatformId]="selectedPlatformId"
        [selectedPeriod]="selectedPeriod"
        [pages]="pages">
      </app-social-ai-trends-chart>

      <app-social-ai-retention-chart
        *ngIf="activeView === 'retention'"
        [selectedSiteId]="selectedSiteId"
        [selectedPlatformId]="selectedPlatformId"
        [selectedPeriod]="selectedPeriod"
        [pages]="pages">
      </app-social-ai-retention-chart>

      <app-social-ai-format-breakdown-chart
        *ngIf="activeView === 'format'"
        [selectedSiteId]="selectedSiteId"
        [selectedPlatformId]="selectedPlatformId"
        [selectedPeriod]="selectedPeriod"
        [platforms]="filteredPlatforms">
      </app-social-ai-format-breakdown-chart>

      <app-social-ai-heatmap-chart
        *ngIf="activeView === 'heatmap'"
        [selectedSiteId]="selectedSiteId"
        [selectedPlatformId]="selectedPlatformId"
        [selectedPeriod]="selectedPeriod"
        [pages]="pages"
        [title]="'Posting Time Heatmap'">
      </app-social-ai-heatmap-chart>

      <app-social-ai-alerts-tab
        *ngIf="activeView === 'alerts'"
        (tabChanged)="onAlertsTabChange($event)"
        [selectedSiteId]="selectedSiteId"
        [selectedPlatformId]="selectedPlatformId"
        [selectedFormat]="selectedFormat"
        [selectedAlertType]="selectedAlertType"
        [pages]="pages"
        [isPageAlerts]="true">
      </app-social-ai-alerts-tab>

    </div>

  </div>

  <!-- RIGHT SIDE -->
  <div class="col-span-12 lg:col-span-3">
    <div class="grid grid-cols-12 gap-4">

      <ng-container *ngFor="let card of getRightCards()">
        <div
          class="col-span-12 bg-white border border-gray-300 rounded-2xl p-4 cursor-pointer transition"
          (click)="card.action()"
        >
          <h3 class="text-sm font-semibold text-gray-800 mb-2">
            {{ card.title }}
          </h3>

          <div class="bg-blue-50 rounded-xl mb-3 h-28 flex items-center justify-center overflow-hidden">
            <img [src]="card.img" class="object-contain w-full h-full" />
          </div>

          <p *ngIf="card.diff" class="text-xs font-semibold text-green-600 mb-1">
            {{ card.diff }}
          </p>

          <a
            (click)="card.action()"
            class="text-xs text-blue-600 font-medium cursor-pointer hover:underline"
          >
            View this metric →
          </a>
        </div>
      </ng-container>

    </div>
  </div>

</div>